export type InputConverterFunc<T> = (value: any) => T;

export let StringConverter: InputConverterFunc<string> = (value: any): string => {
    if (value === null || value === undefined || typeof value === 'string') { return value; }
    return value.toString();
};
export let BooleanConverter: InputConverterFunc<boolean> = (value: any): boolean => {
    if (value === null || value === undefined || typeof value === 'boolean') { return value; }
    return value.toString().toLowerCase() === 'true';
};
export let NumberConverter: InputConverterFunc<number> = (value: any): number => {
    if (value === null || value === undefined || typeof value === 'number') { return value; }
    return parseFloat(value.toString());
};
export let JSONConverter: InputConverterFunc<any> = (value: any): any => {
    if (value === null || value === undefined || typeof value === 'object') { return value; }
    return JSON.parse(value.toString());
};
export function InputConverter(converter?: InputConverterFunc<any>) {
    return (target: Object, key: string) => {
        if (!converter) {
            const metadata = (<any>Reflect).getMetadata('design:type', target, key);
            if (metadata === undefined || metadata === null) {
                throw new Error('The reflection metadata could not be found.');
            }

            switch (metadata.name) {
                case 'String':
                    converter = StringConverter;
                    break;
                case 'Boolean':
                    converter = BooleanConverter;
                    break;
                case 'Number':
                    converter = NumberConverter;
                    break;
                default:
                    throw new Error(`There is no converter for the given property type '${metadata.name}'.`);
            }
        }

        const definition = Object.getOwnPropertyDescriptor(target, key);
        if (definition) {
            // TODO: This may not work...
            Object.defineProperty(target, key, {
                configurable: true,
                enumerable: true,
                get() {
                    return definition.get();
                },
                set(newValue) {
                    definition.set(converter(newValue));
                }
            });
        } else {
            Object.defineProperty(target, key, {
                configurable: true,
                enumerable: true,
                get() {
                    return this['__' + key];
                },
                set(newValue) {
                    this['__' + key] = converter(newValue);
                }
            });
        }
    };
}
